import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
  attachmentIcon: {
    width: 30,
    height: 30,
    background: "#F9F9F9",
    border: "solid 1px #F1F1F1",
    borderRadius: "50% !important",
    minWidth: "auto",
    position: "relative",
    "& svg": {
      width: 18,
      transform: "rotate(45deg)",
    },
  },
  attachmentCount: {
    fontSize: 12,
    height: 20,
    width: 20,
    borderRadius: "50%",
    display: "block",
    background: "#fff",
    position: "absolute",
    top: -5,
    right: -14,
    textAlign: "center",
    fontWeight: 500,
    boxShadow: "0px 0px 6px #00000029",
  },
  attachmentList: {
    margin: 0,
    padding: 0,
    listStyle: "none",
    "& a": {
      textDecoration: "none",
      color: theme.palette.primary.main,
    },
    "& li": {
      borderBottom: "1px solid rgb(112 112 112 / 16%)",
      display: "flex",
      alignItems: "center",
      padding: "10px 0",
      "&:last-child": {
        border: "none",
      },
      "& img": {
        width: 16,
        minWidth: 16,
        marginRight: 10,
        height: "auto",
      },
      "& svg": {
        width: 16,
        minWidth: 16,
        marginRight: 10,
        height: "auto",
      },
    },
  },
  popper: {
    // height: 200,
    width: 250,
    zIndex: "2 !important",
    "& h6": {
      color: "#202f43",
    },
  },
  borderBottom: {
    borderBottom: "solid 1px #dedede",
  },
  paper: {
    overflow: "auto !important",
    padding: 4,
  },
  fileName: {
    fontSize: 12,
  },
}));
